/**
 * Mixpanel event constants for Claims Table and Details Drawer tracking
 * Follows SafeLease event naming pattern: "Event Name - Page Name"
 * These events are used to track feature adoption, engagement, and product impact
 */

export const CLAIMS_MIXPANEL_EVENTS = {
  // Adoption Events (New Feature)
  table: {
    viewed: "Claims Table - Dashboard",
    rowClicked: "Claims Table Row Clicked - Dashboard",
    claimIdCopied: "Claims Table Claim ID Copied - Dashboard",
    paginationChanged: "Claims Table Pagination Changed - Dashboard",
    sortChanged: "Claims Table Sort Changed - Dashboard",
    statusLegendOpened: "Claims Table Status Legend Opened - Dashboard",
  },
  // Engagement Events (Feature Value Moment)
  drawer: {
    opened: "Claims Drawer Opened - Dashboard",
    closed: "Claims Drawer Closed - Dashboard",
    claimIdCopied: "Claims Drawer Claim ID Copied - Dashboard",
    accordionExpanded: "Claims Drawer Accordion Expanded - Dashboard",
    accordionCollapsed: "Claims Drawer Accordion Collapsed - Dashboard",
    emailClicked: "Claims Drawer Email Clicked - Dashboard",
    phoneClicked: "Claims Drawer Phone Clicked - Dashboard",
    statusTooltipViewed: "Claims Drawer Status Tooltip Viewed - Dashboard",
    safeleaseEmailClicked: "Claims Drawer SafeLease Email Clicked - Dashboard",
  },
};

/**
 * Accordion type constants for tracking which accordion section was expanded
 */
export const ACCORDION_TYPES = {
  TENANT_ACTIONS: "tenant_actions",
  CLAIM_DETAILS: "claim_details",
  LOSS_DESCRIPTION: "loss_description",
  LINE_ITEMS: "line_items",
  DOCUMENTS: "documents",
} as const;

export type AccordionType = (typeof ACCORDION_TYPES)[keyof typeof ACCORDION_TYPES];
